import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { LogService } from '../../core/log/log.service';
import { onlyWhenOnline, onlyWhenReady } from '../../shared/util/operators';
import { ErrorMessage, ErrorType } from '../error/error-message.model';
import { loadTopic, loadTopicSuccess, loadTopicFailure } from './topic.actions';
import { Topic } from './topic.model';
import { TopicService } from './topic.service';

@Injectable({ providedIn: 'root' })
export class TopicEffects {
	loadTopic$ = createEffect(() =>
		this.actions$.pipe(
			ofType(loadTopic),
			onlyWhenOnline(this.store),
			onlyWhenReady(this.store),
			tap((action) => this.logService.info('Effect: loadTopic', action)),
			switchMap(() =>
				this.topicService.loadTopic().pipe(
					tap((data: Topic[]) =>
						this.logService.infoDebug('Effect: loadTopic data received --> ', data)
					),
					map((datiTopic: Topic[]) => {
						// Una lista vuota non e' uno stato atteso (sidenav, rotta /topic e guardia
						// specializzazione ne dipendono): la si tratta come un fallimento, cosi' finisce
						// nel log e in topicList.error, e chi aspetta i topic ripiega invece di appendersi.
						if (datiTopic.length === 0) {
							const error = new ErrorMessage('loadTopic: empty topic list');
							error.Code = ErrorType.ErrorRecordsetEmpty;
							error.messageDN = 'loadTopic: empty topic list';
							this.logService.error('Effect: loadTopic received an empty list', error);
							return loadTopicFailure({ error });
						}
						return loadTopicSuccess({ datiTopic });
					}),
					catchError((error: ErrorMessage) => of(loadTopicFailure({ error })))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private logService: LogService,
		private store: Store,
		private topicService: TopicService
	) {}
}
